import { gql } from "@apollo/client";

export const CREATE_FRANCHISE = gql`
  mutation createFranchise($data: CreateFranchiseInput!) {
    createFranchise(data: $data) {
      id
      name
    }
  }
`;

export const UPDATE_FRANCHISE = gql`
  mutation updateFranchise($data: UpdateFranchiseInput!) {
    updateFranchise(data: $data) {
      id
      name
    }
  }
`;

export default CREATE_FRANCHISE;
